import { render, staticRenderFns } from "./BusinessNameFilingHistory.vue?vue&type=template&id=1078ae15&scoped=true&"
import script from "./BusinessNameFilingHistory.vue?vue&type=script&lang=js&"
export * from "./BusinessNameFilingHistory.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameFilingHistory.vue?vue&type=style&index=0&id=1078ae15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1078ae15",
  null
  
)

export default component.exports